module.exports = __webpack_public_path__ + "img/customer-service.b7285567.svg";